import { FunctionComponent } from 'react';
import './styles/Checkbox.scss';
import { classNames } from '../../utils';

interface ICheckboxProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  name?: string;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  title?: string;
  size?: 'medium' | 'small';
}
export const Checkbox: FunctionComponent<ICheckboxProps> = (props: ICheckboxProps) => {

  const {
    checked,
    onChange,
    title,
    name,
    required,
    readOnly,
    disabled,
    size
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  }

  return (
    <input
      type='checkbox'
      title={title ?? 'Select'}
      checked={checked}
      onChange={handleChange}
      name={name}
      required={required}
      readOnly={readOnly}
      disabled={disabled}
      className={classNames('ppa-schedule-checkbox', `size-${size ?? 'medium'}`)}
    />
  );
}